module.exports = __webpack_public_path__ + "static/media/jhola.3fbe3ebe.ogg";